/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy Counselor API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import promiseRetry from "promise-retry";
import { forceRefreshAccessToken } from "@mgdx-libs/firebase";
import * as runtime from "../runtime";
import {
  GetCounselingWaitingTimesResponse,
  GetCounselingWaitingTimesResponseFromJSON,
  GetCounselingWaitingTimesResponseToJSON,
  PharmacyCounselorCustomBadRequest4,
  PharmacyCounselorCustomBadRequest4FromJSON,
  PharmacyCounselorCustomBadRequest4ToJSON,
  PutCounselingWaitingLabelRequestBody,
  PutCounselingWaitingLabelRequestBodyFromJSON,
  PutCounselingWaitingLabelRequestBodyToJSON,
} from "../models";

export interface GetCounselingWaitingTimesRequest {
  pharmacyId: number;
  window: number;
  patientDelayTime: number;
  waitingPatientCount: number;
  type?: Array<GetCounselingWaitingTimesTypeEnum>;
}

export interface PutCounselingWaitingLabelRequest {
  counselingId: number;
  putCounselingWaitingLabelRequestBody: PutCounselingWaitingLabelRequestBody;
}

/**
 *
 */
export class CounselingWaitingLabelApi extends runtime.BaseAPI {
  /**
   * Get counseling waiting times
   */
  async getCounselingWaitingTimesRaw(
    requestParameters: GetCounselingWaitingTimesRequest,
    initOverrides?: RequestInit
  ): Promise<runtime.ApiResponse<GetCounselingWaitingTimesResponse>> {
    if (requestParameters.pharmacyId === null || requestParameters.pharmacyId === undefined) {
      throw new runtime.RequiredError(
        "pharmacyId",
        "Required parameter requestParameters.pharmacyId was null or undefined when calling getCounselingWaitingTimes."
      );
    }

    if (requestParameters.window === null || requestParameters.window === undefined) {
      throw new runtime.RequiredError(
        "window",
        "Required parameter requestParameters.window was null or undefined when calling getCounselingWaitingTimes."
      );
    }

    if (requestParameters.patientDelayTime === null || requestParameters.patientDelayTime === undefined) {
      throw new runtime.RequiredError(
        "patientDelayTime",
        "Required parameter requestParameters.patientDelayTime was null or undefined when calling getCounselingWaitingTimes."
      );
    }

    if (requestParameters.waitingPatientCount === null || requestParameters.waitingPatientCount === undefined) {
      throw new runtime.RequiredError(
        "waitingPatientCount",
        "Required parameter requestParameters.waitingPatientCount was null or undefined when calling getCounselingWaitingTimes."
      );
    }

    const queryParameters: any = {};

    if (requestParameters.pharmacyId !== undefined) {
      queryParameters["pharmacy_id"] = requestParameters.pharmacyId;
    }

    if (requestParameters.window !== undefined) {
      queryParameters["window"] = requestParameters.window;
    }

    if (requestParameters.patientDelayTime !== undefined) {
      queryParameters["patient_delay_time"] = requestParameters.patientDelayTime;
    }

    if (requestParameters.waitingPatientCount !== undefined) {
      queryParameters["waiting_patient_count"] = requestParameters.waitingPatientCount;
    }

    if (requestParameters.type) {
      queryParameters["type"] = requestParameters.type;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/counselings/waiting-times`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => GetCounselingWaitingTimesResponseFromJSON(jsonValue));
  }

  /**
   * Get counseling waiting times
   */
  async getCounselingWaitingTimes(
    requestParameters: GetCounselingWaitingTimesRequest,
    initOverrides?: RequestInit
  ): Promise<GetCounselingWaitingTimesResponse> {
    return promiseRetry(
      (retry) =>
        this.getCounselingWaitingTimesRaw(requestParameters, initOverrides)
          .catch(async (error: Response) => {
            if (error.status === 401) {
              const accessToken = await forceRefreshAccessToken();
              if (accessToken) {
                retry(error);
              }
            }
            throw error;
          })
          .then(async (response) => {
            return await (response as any).value();
          }),
      {
        // The maximum amount of times to retry the operation. Default is 10.
        retries: 5,
        // The exponential factor to use. Default is 2.
        factor: 4,
        // The number of milliseconds before starting the first retry. Default is 1000.
        // minTimeout: 1000,
        // The maximum number of milliseconds between two retries. Default is Infinity.
        // maxTimeout: 60000,
        // Randomizes the timeouts by multiplying with a factor between 1 to 2. Default is false.
        // randomize: false,
      }
    ).catch((error) => {
      throw error;
    });
  }

  /**
   * Update counseling waiting label
   */
  async putCounselingWaitingLabelRaw(
    requestParameters: PutCounselingWaitingLabelRequest,
    initOverrides?: RequestInit
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters.counselingId === null || requestParameters.counselingId === undefined) {
      throw new runtime.RequiredError(
        "counselingId",
        "Required parameter requestParameters.counselingId was null or undefined when calling putCounselingWaitingLabel."
      );
    }

    if (
      requestParameters.putCounselingWaitingLabelRequestBody === null ||
      requestParameters.putCounselingWaitingLabelRequestBody === undefined
    ) {
      throw new runtime.RequiredError(
        "putCounselingWaitingLabelRequestBody",
        "Required parameter requestParameters.putCounselingWaitingLabelRequestBody was null or undefined when calling putCounselingWaitingLabel."
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/counselings/{counseling_id}/counseling-waiting-label`.replace(
          `{${"counseling_id"}}`,
          encodeURIComponent(String(requestParameters.counselingId))
        ),
        method: "PUT",
        headers: headerParameters,
        query: queryParameters,
        body: PutCounselingWaitingLabelRequestBodyToJSON(requestParameters.putCounselingWaitingLabelRequestBody),
      },
      initOverrides
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Update counseling waiting label
   */
  async putCounselingWaitingLabel(
    requestParameters: PutCounselingWaitingLabelRequest,
    initOverrides?: RequestInit
  ): Promise<void> {
    await this.putCounselingWaitingLabelRaw(requestParameters, initOverrides);
  }
}

/**
 * @export
 * @enum {string}
 */
export enum GetCounselingWaitingTimesTypeEnum {
  OnlineCounseling = "online_counseling",
  Dispensing = "dispensing",
  DirectVisit = "direct_visit",
}
